import React, {Component} from 'react';
import {Link} from "react-router-dom";
import DataFormat from "../../utilities/DateAndTimeFormat";
import moment from "moment";
import LogowanieService from "../../modules/logowanie/LogowanieService";
import {ButtonToolbar, DropdownButton, MenuItem} from "react-bootstrap";
import LSService from "../../utilities/localStorageService/LSService";
import AppConfig from "../../AppConfig";

class SubHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            obecnaData: DataFormat.formatYYYYMMDD(moment(moment.now()))
        }
        this.onClickWyloguj = this.onClickWyloguj.bind(this);
        this.onClickDropItem = this.onClickDropItem.bind(this);
        this.onClickZglosProblem = this.onClickZglosProblem.bind(this);
    }

    onClickWyloguj() {
        LogowanieService.wyloguj()
        if (Boolean(this.props.history)) {
            this.props.history.push('/')
        }
    }

    onClickZglosProblem() {


        let login = LogowanieService.pobierzZalogowanego().login
        let imienazwisko = ''
        if (Boolean(LogowanieService.pobierzZalogowanego().imie) && LogowanieService.pobierzZalogowanego().nazwisko) {
            imienazwisko = LogowanieService.pobierzZalogowanego().imie + '&nbsp;' + LogowanieService.pobierzZalogowanego().nazwisko
        }
        let emajl = Boolean(LogowanieService.pobierzZalogowanego().email) ? LogowanieService.pobierzZalogowanego().email : ''

        let zgl = login + '&nbsp;' + imienazwisko + '&nbsp;' + emajl


        this.props.history.push('?app=MARCEL_APP&&id=100&&klid=124&&zgl=' + zgl)
        window.open('https://projekty.topsa.com.pl/App/ZgloszenieUwagi', '_blank');
        //window.open('http://projekty.top/App/ZgloszenieUwagi','_blank');
        // window.open('http://localhost:3000/App/ZgloszenieUwagi','_blank');
    }

    onClickDropItem(item, url) {
        window.open(url, '_blank');
    }

    render() {
        return (
            <div className="pull-right">
                {
                    AppConfig.APP_VER().indexOf('prod') === -1 &&
                    <span style={{
                        marginRight: '15px',
                        color: 'white',
                        display: 'inline-block',
                        background: 'orange',
                        padding: '5px',
                        fontWeight: 'bold'
                    }}>
                    {
                        AppConfig.APP_VER().indexOf('dev') > -1 && 'WERSJA DEV'
                    }
                        {
                            AppConfig.APP_VER().indexOf('test') > -1 && 'WERSJA TEST'
                        }
                </span>
                }
                <span style={{marginRight: '15px'}} className={'hideOnSmallerScreens'}>
                    Obecna data: <span style={{fontWeight: 'normal', color: '#58b13d'}}>{this.state.obecnaData}</span>
                    {
                        Boolean(this.props.obecnyKalendarz) ?
                            <span>, kalendarz: <span style={{fontWeight: 'normal', color: '#58b13d'}}>{this.props.obecnyKalendarz.nazRk}</span></span>
                            :
                            ''
                    }
                </span>
                <div id={'MainModulesLinksContainer'}>
                    {/*<Link to={'/obsluga'}>
                        <button className={(this.props.currentLink.indexOf('obsluga') !== -1) ? 'btn btn-default btn-current' : 'btn btn-default'}>
                            Obsługa
                        </button>
                    </Link>
                    <Link to={'/konfiguracja'}>
                        <button
                            className={(this.props.currentLink.indexOf('konfiguracja') !== -1) ? 'btn btn-default btn-current' : 'btn btn-default'}>
                            Konfiguracja
                        </button>
                    </Link>*/}
                    <Link to={'/home'}>
                        <button className={(this.props.currentLink.indexOf('konto') !== -1) ? 'btn btn-default btn-current' : 'btn btn-default'}><i
                            className={'fa fa-user'} style={{marginRight: '5px'}}></i>{LogowanieService.pobierzLoginZalogowanego()}
                        </button>
                    </Link>
                </div>
                <div className="divider hideOnSmallerScreens"></div>
                {/*<div id="logOutContainer">
                    <button className={'btn btn-danger'} onClick={this.onClickWyloguj}><i className={'fa fa-power-off'}></i></button>
                </div>*/}
                <div id="logOutContainer">
                    <DropdownButton
                        bsStyle="default"
                        noCaret
                        pullRight
                        id="dropdown-no-caret"
                        title={<i style={{color: 'dodgerblue'}} className={'fa fa-info-circle'} title="Pokaż dokumentację"></i>}
                    >
                        <MenuItem eventKey="1"
                                  onClick={() => this.onClickDropItem(1, 'https://docs.google.com/document/d/1S-91PgSAXNNmae1-ZSRWKT4fyykPBufJX9Qnw-8odt8/edit?usp=sharing')}><a>Dokumentacja
                            ogólna</a></MenuItem>
                        <MenuItem eventKey="2"
                                  onClick={() => this.onClickDropItem(2, 'https://docs.google.com/document/d/1GDHnfdS9joqsr10c9LaKz1c59pagH7U8v86_nFhPq4k/edit?usp=sharing')}><a>Przewodnik
                            po konfiguracji nowej trasy</a></MenuItem>
                        <MenuItem eventKey="3"
                                  onClick={() => this.onClickDropItem(3, 'https://docs.google.com/document/d/1P4_aHz4Tu0jR4jSVw8CY-iZh9JWWMNvDorYENesiCBY/edit?usp=sharing')}><a>Przewodnik
                            po generowaniu danych na nowy okres</a></MenuItem>
                        <MenuItem eventKey="4"
                                  onClick={() => this.onClickDropItem(4, 'https://docs.google.com/document/d/1aIXpRyw_nhL-_CGGUTGlO1nlftSDRda_XTBXgdGjFWw/edit?usp=sharing')}><a>Przewodnik
                            po aktualizacji cenników pomiędzy systemami</a></MenuItem>
                        <MenuItem eventKey="5"
                                  onClick={() => this.onClickDropItem(5, 'https://docs.google.com/document/d/16pgXOtEXVmA5jW70SFke6QFrn7_nSN_wzIma9ODx9Y8/edit')}><a>Konfiguracja
                            połączenia drukarki z telefonem</a></MenuItem>
                        <MenuItem eventKey="6"
                                  onClick={() => this.onClickDropItem(6, 'https://docs.google.com/document/d/1eHSDrWyFCDUysmbYPQsUiuTyc3h7_i5dnO60-ClcgLM/edit')}><a>Dokumentacja
                            aplikacji TOP eBus DRIVER</a></MenuItem>
                    </DropdownButton>


                    {/*<button type={'button'} className={'btn btn-default'} style={{color:'dodgerblue'}} title={'Pokaż dokumentację'}><i className={'fa fa-info-circle'}></i></button>*/}
                    <button onClick={this.onClickZglosProblem} type={'button'} className={'btn btn-default'}
                            style={{color: 'firebrick', margin: '0 5px'}} title={'Zgłoś błąd'}><i className={'fa fa-exclamation-triangle'}></i>
                    </button>
                    <button className={'btn btn-danger'} onClick={this.onClickWyloguj} title="Wyloguj się"><i className={'fa fa-power-off'}></i>
                    </button>
                </div>
            </div>
        );
    }
}

export default SubHeader;


// WEBPACK FOOTER //
// ./src/shared/sidebar/SubHeader.js